<template>
  <div class="fix-height">
    <q-field
      ref="customWage"
      class="customWage"
      :dense="dense"
      stack-label
      filled
      color="orange-custom"
      :label="convertLabel"
      :disable="disabled||!editable"
      :rules="!required ? null : [val => !!val || '']"
      v-model="valueText"
      >
      <template v-slot:label v-if="label">
        <div class="row items-center all-pointer-events">
          <b>
            <i v-if="!required" class="pe-7s-note labelfrontIcon searchAreaLabelIcon"></i>
            <font class="formLabelTitle">{{convertLabel}}</font>
            <i v-if="required" class="material-icons labelfrontIcon text-requiredColor">check</i>
          </b>
        </div>
      </template>
      <template v-slot:control>
        <div class="full-width text-right">
          {{ valueText }}
        </div>
      </template>

      <template v-slot:append>
        <q-icon v-if="!disabled&&editable" name="search" @click="search" class="cursor-pointer"></q-icon>
        <q-icon v-if="!disabled&&editable" name="close" @click="reset" class="cursor-pointer"></q-icon>
      </template>
    </q-field>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
import mixinCommon from './js/mixin-common'
export default {
  name: 'c-wage',
  mixins: [mixinCommon],
  props: {
    name: {
      type: String,
      default: 'field',
    },
    // TODO : 부모의 v-model의 값을 받아오는 속성
    value: { // 사용자의 id를 받아 처리
      type: [String, Number],   // ← 여기!
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    // 쓰기 권한 여부
    editable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    // 필수 입력 여부
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    plantCd: {
      type: String,
      default: '',
    },
    searchType: {
      type: String,
      default: 'DISA',
    },
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      vValue: null,
      valueText: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '60%',
        param: {},
        closeCallback: null,
      },
      saveUrl: null,
      deleteUrl: null,
      listUrl: null,
      wage: null,
    };
  },
  computed: {
  },
  watch: {
    // todo : 부모의 v-model 변경을 감시
    value: {
      handler: function () {
        if (this.value !== null) {
          this.vValue = this.value;
          this.getList();
          // this.setValueText();
        } else {
          this.$emit('input', null);
          this.valueText = '';
        }
      },
      deep: true,
    },
  },
  /* Vue lifecycle: created, mounted, destroyed, etc */
  beforeMount() {
    this.vValue = this.value;
    this.listUrl = selectConfig.sop.iim.accident.wage.grpList.url
    this.saveUrl = transactionConfig.sop.iim.accident.wage.save.url
    this.deleteUrl = transactionConfig.sop.iim.accident.wage.delete.url
    this.setValueText();
  },
  mounted() {
    if (!this.disabled) {
      this.$refs['customWage'].$el.getElementsByClassName('q-field__native')[0].addEventListener('click', this.search);
    }
  },
  beforeDestroy() {
    if (!this.disabled) {
      this.$refs['customWage'].$el.getElementsByClassName('q-field__native')[0].addEventListener('click', this.search);
    }
  },
  /* methods */
  methods: {
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        iimAccidentId: this.data.iimAccidentId,
        wageType: this.searchType
      }
      this.$http.request((_result) => {
        this.wage = _result.data;
        this.setValueText();
      },);
    },

    formatCost(val) {
      if (val === null || val === undefined || val === '') {
        return '';
      }

      // 숫자만 뽑아서 변환 (혹시 문자열에 다른 문자가 섞여 있어도)
      const num = Number(String(val).replace(/[^0-9.-]/g, ''));
      if (isNaN(num)) {
        return String(val); // 숫자로 못 바꾸면 원본 그대로
      }

      // 필요하면 뒤에 '원' 붙이기
      return num.toLocaleString('ko-KR'); // + '원';
    },

    /**
     * v-model로 받은 값을 통해 사용자 정보 조회
     *
     * type에 따라 valueText에 표시되는 값 변경
     */
    setValueText() {
      if (!this.wage) {
        this.valueText = '';
        return;
      }

      this.valueText = this.formatCost(this.wage.sumWage);
    },
    search() {
      if (!this.data.iimAccidentId) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '신규등록시 먼저 저장하세요.', 
          type: 'warning', // success / info / warning / error
        });
        return;
      } else if (!this.data.accidentUserId) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '사고자를 선택하세요.', 
          type: 'warning', // success / info / warning / error
        });
        return;
      } else if (!this.data.accidentStartDate) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '요양기간을 선택하세요.', 
          type: 'warning', // success / info / warning / error
        });
        return;
      }
      this.popupOptions.title = this.searchType === 'DISA' ? '장해보상금' : '산재생계보조금'; 
      this.popupOptions.param = {
        type: "multiple",
        wageType: this.searchType,
        accidentUserId: this.data.accidentUserId,
        iimAccidentId: this.data.iimAccidentId,
        startDt: this.data.accidentStartDate,
        endDt: this.data.accidentEndDate,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/iim/reg/wagePop.vue"}`);
      this.popupOptions.width = "40%";
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.wageList = data;
        
        this.$_.forEach(data, _item => {
          _item.iimAccidentId = this.data.iimAccidentId
          _item.accidentUserId = this.data.accidentUserId
        })
        this.$http.url = this.saveUrl;
        this.$http.type = "POST";
        this.$http.param = data
        this.$http.request((_result) => {
          const rawVal = _result.data && _result.data.sumWage
            ? _result.data.sumWage
            : _result.data;

          this.valueText = this.formatCost(rawVal);
          this.$emit('input', rawVal);
          this.$emit('dataChange', rawVal);
        });
      }
    },
    reset() {
      this.valueText = '';
      this.$emit('input', null);
      this.$emit('dataChange', null);
      this.$emit('remove', null);
      this.$http.url = this.$format(this.deleteUrl, this.data.iimAccidentId, this.searchType);
      this.$http.type = "DELETE";
      this.$http.request(() => {});
    },
  },
};
</script>
<style lang="sass">
.customWage
  padding-bottom: 20px !important
  .q-field__native.row
    padding-left: 3px
    font-size: 0.95em
    padding-top: 4px !important
  .q-field__native
    padding-bottom: 6px !important
    cursor: pointer
  .q-field__label
    margin-left: 5px
  .material-icons
    font-size: 0.8rem
  .dateCloseIcon
    font-size: 0.8rem !important
    display: none
.customWage:hover
  .dateCloseIcon
    display: block
.customWage.q-field--dense .q-field__control, .customWage.q-field--dense .q-field__marginal
  height: 33px !important
  min-height: 33px !important
.customWage.q-field--filled .q-field__control
  border: 1px solid rgba(0,0,0,0.15) !important
  padding: 0px 8px 0px 2px
</style>